import React, { useRef, useState } from "react";
import { Form, Alert } from "react-bootstrap";
import Button from "../../components/UI/Button/Button";
import { useAuth } from "../../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import Form__separator from "../../components/UI/Form/Form__separator/Form__separator";
import Section from "../../components/UI/Section/Section";

export default function Signup() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { signup } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  async function handleSubmit(e) {
    e.preventDefault();

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Пароли не совпадают");
      window.scrollTo(0, 0);
    }

    try {
      setError("");
      setLoading(true);
      await signup(emailRef.current.value, passwordRef.current.value);
      history.push("/check-user-data");
    } catch (e) {
      setError("Не удается создать аккаунт " + e);
      console.log(e);
      window.scrollTo(0, 0);
    }

    setLoading(false);
  }

  return (
    <>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit} className="Form Form_type_welcome-form">
        <h2 className="Heading Form__title">Регистрация</h2>
        <Form.Group id="email" className="Form__group">
          <Form.Label>Email</Form.Label>
          <Form.Control type="email" ref={emailRef} required />
        </Form.Group>
        <Form.Group id="password" className="Form__group">
          <Form.Label> Пароль</Form.Label>
          <Form.Control type="password" ref={passwordRef} required />
        </Form.Group>
        <Form.Group id="password-confirm" className="Form__group">
          <Form.Label>Подтверждение</Form.Label>
          <Form.Control type="password" ref={passwordConfirmRef} required />
        </Form.Group>
        <Form.Group className="Form__group">
          <Button disabled={loading} className="Form__submit" type="submit">
            Регистрация
          </Button>
        </Form.Group>
        <Form.Group className="Form__group">
          <Form__separator />
        </Form.Group>
        <Link className="Form__link" to="/login">
          Войти
        </Link>
      </Form>
      <Section>
        <p style={{opacity:0.5, margin: "28px 0 28px", textAlign:"center", fontSize:"14px", fontWeight: "300"}}>
          Продолжая использовать приложение, вы соглашаетесть с&nbsp;
          <Link to="/privacy" className="Form__link" style={{color:"inherit"}}>Политикой</Link>
        </p>
      </Section>
    </>
  );
}
